import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const IronIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "IronIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.3602 17.2607C12.043 17.2607 11.7856 17.5181 11.7856 17.8353V20.1336C11.7856 20.451 12.043 20.7082 12.3602 20.7082C12.6776 20.7082 12.9348 20.451 12.9348 20.1336V17.8353C12.9348 17.5181 12.6776 17.2607 12.3602 17.2607Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.16975 17.3215C8.88606 17.1797 8.54086 17.2946 8.39887 17.5784L7.24973 19.8767C7.10788 20.1606 7.2228 20.5056 7.50664 20.6476C7.79093 20.7896 8.13583 20.6741 8.27752 20.3907L9.42666 18.0924C9.56866 17.8086 9.45359 17.4634 9.16975 17.3215Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.3215 17.5784C16.1797 17.2947 15.8345 17.1796 15.5507 17.3215C15.2668 17.4633 15.1517 17.8085 15.2937 18.0924L16.4429 20.3907C16.5844 20.6739 16.9293 20.7897 17.2136 20.6476C17.4975 20.5057 17.6125 20.1605 17.4707 19.8767L16.3215 17.5784Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.5917 3.47168H10.0238C9.70643 3.47168 9.44922 3.72889 9.44922 4.04625C9.44922 4.36361 9.70643 4.62082 10.0238 4.62082H21.0171V8.06825H10.1188C5.82148 8.06825 3.27691 11.1546 2.56213 15.4431C2.50392 15.7927 2.77355 16.1123 3.12892 16.1123H21.5917C21.909 16.1123 22.1662 15.8549 22.1662 15.5377V4.04625C22.1662 3.72889 21.909 3.47168 21.5917 3.47168ZM21.0171 14.9631H3.82545C4.64092 11.3005 6.90689 9.2174 10.1188 9.2174H21.0171V14.9631Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default IronIcon;
